export const SOF = 0x3c;
export const EOF = 0x3e;
export const CRC_POLY = 0x8005;

/**
 * 기기 타임스탬프 기준 에폭 (Device time epoch) — 단일 소스(SSOT)
 *
 * BellLite/BellMini 기기는 모든 시각을 "2023-01-01 00:00:00 **UTC** 이후 흐른 초"로 전송한다.
 * (펌웨어 팀 확인: 기준은 KST가 아니라 UTC)
 *
 * 이 값은 시각을 다루는 모든 경로에서 반드시 공유해야 한다:
 *  - 실시간/설정 통신: packages/utils/device/converters/formatCodec.ts (date_seconds_from_basedate 등)
 *  - 실시간 저장: apps/backend/src/bellconnect/bellconnect.service.ts (convertToTimestamp)
 *  - 업로드 로그 파싱: apps/backend/src/device/parsers/* (gas-reading/event-log/config/calibration/gas-alarm)
 *
 * ⚠️ 여기를 KST 등 다른 기준으로 바꾸면 저장 시각이 통째로 어긋난다. 절대 로컬 타임존으로 재정의하지 말 것.
 */
export const BASE_DATE = Date.UTC(2023, 0, 1); // 2023-01-01T00:00:00Z (ms)
/** BASE_DATE의 초 단위 표현. "seconds since 2023.01.01(UTC)" 계산에 사용 */
export const DEVICE_EPOCH_SECONDS = BASE_DATE / 1000; // 1672531200
export const DEFAULT_SEQ = 0x01;
export const MINI_DST = 0x01;
export const LITE_DST = 0x05;
export const DEFAULT_SRC = 0x02;
export const SERVICE_UUID_WITH_HYPHENS = '2456e1b9-26e2-8f83-e744-f34f01e9d701';
export const DATA_CHAR_UUID_WITH_HYPHENS = '2456e1b9-26e2-8f83-e744-f34f01e9d703';
export const BAUD_RATE = 115200;
export const GAS_CONC_SCALE = 1000;
